
import React from 'react';
import { SimulationConfig } from '@/types';

interface MidiPitchHistogramProps {
    notes: any[];
    minPitch: number;
    maxPitch: number;
    darkMode: boolean;
    config: SimulationConfig;
}

export const MidiPitchHistogram: React.FC<MidiPitchHistogramProps> = ({ notes, minPitch, maxPitch, darkMode, config }) => {
    const counts = new Array(128).fill(0);
    notes.forEach(n => {
        if (n.midi >= 0 && n.midi < 128) counts[n.midi]++;
    });
    
    const maxCount = Math.max(...counts, 1);

    return (
        <div className={`p-4 rounded-2xl border ${darkMode ? 'bg-black/40 border-white/5' : 'bg-white border-zinc-950/5 shadow-inner'}`}>
            <div className="flex flex-col gap-1 mb-4">
                <span className="text-[9px] font-display font-black uppercase tracking-[0.2em] opacity-30">Frequency Distribution</span>
                <span className="text-[8px] font-mono opacity-20 uppercase">Pitch Spectrum Analysis</span>
            </div>
            
            <div className="flex items-end justify-between gap-px h-24 w-full">
                {counts.map((c, i) => {
                    const active = i >= minPitch && i <= maxPitch;
                    const height = (c / maxCount) * 100;
                    
                    return (
                        <div 
                            key={i} 
                            style={{ height: `${height}%` }}
                            className={`flex-1 min-w-[2px] transition-all duration-300 rounded-t-sm ${active ? 'bg-blue-500 opacity-80' : 'bg-zinc-500/20'}`}
                        />
                    );
                })}
            </div>
            
            <div className="flex justify-between mt-2 pt-2 border-t border-white/5 px-1">
                <span className="text-[8px] font-mono opacity-30">C0</span>
                <span className="text-[8px] font-mono opacity-30">C4</span>
                <span className="text-[8px] font-mono opacity-30">C8</span>
            </div>
        </div>
    );
};
